export default "__VITE_ASSET__db6814e5__"